import { Deployment } from "../../../types/Deployment";
import {
    clamp as clampDate,
    getDateRange,
    isSameDayDate,
} from "../../../shared/lib/temporal";

/**
 * Ensure a date falls within deployment boundaries
 */
export function clampDateToDeployment(
    date: Date,
    deployment: Deployment,
): Date {
    return clampDate(date, deployment.startTime, deployment.endTime);
}

/**
 * Get the overall date range for the date picker bounds
 */
export function getDeploymentDateRange(deployments: Deployment[]) {
    if (!deployments.length) {
        return { min: null, max: null };
    }

    const dates = deployments.flatMap((d) => [d.startTime, d.endTime]);
    return getDateRange(dates);
}

/**
 * Check if a date should be disabled in the date picker
 */
export function shouldDisableDate(
    date: Date,
    deployments: Deployment[],
    timezone: string,
): boolean {
    const result = !deployments.some(
        (d) =>
            isSameDayDate(date, d.startTime, timezone) ||
            isSameDayDate(date, d.endTime, timezone) ||
            (date > d.startTime && date < d.endTime),
    );
    return result;
}
